import { render, staticRenderFns } from "./ButtonCta.vue?vue&type=template&id=26f2f73b&scoped=true"
import script from "./ButtonCta.vue?vue&type=script&lang=js"
export * from "./ButtonCta.vue?vue&type=script&lang=js"
import style0 from "./ButtonCta.vue?vue&type=style&index=0&id=26f2f73b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f2f73b",
  null
  
)

export default component.exports